import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchSiteConfig } from "../services/SiteConfigService";
import { apiGet } from "../services/BaseService";

const Footer: React.FC = () => {
  const [homePageMode, setHomePageMode] = useState<string>("advanced");

  useEffect(() => {
    const loadConfig = async () => {
      try {
        // First try to use the service function
        try {
          const config = await fetchSiteConfig();
          setHomePageMode(config.homePageMode);
        } catch (serviceError) {
          // Fallback to direct API call if service fails
          try {
            const config = await apiGet('/site-config');
            setHomePageMode(config.homePageMode);
          } catch (error) {
            console.error('Failed to fetch site config:', error);
          }
        }
      } catch (error) {
        console.error("Failed to load site configuration:", error);
      }
    };

    loadConfig();
  }, []);
  return (
    <footer className="bg-dark text-white py-4 mt-auto">
      <div className="container">
        <div className="row">
          <div className="col-md-4 mb-3">
            <h5 className="text-warning">Natakiya</h5>
            <p className="small">Your gateway to the world of theater. Discover amazing plays and connect with theater groups.</p>
          </div>
          <div className="col-md-2 mb-3">
            <h6>Explore</h6>
            <ul className="list-unstyled small">
              <li><Link to="/" className="text-light text-decoration-none">Home</Link></li>
              {homePageMode === "advanced" ? (
                <>
                  <li><Link to="/plays" className="text-light text-decoration-none">Plays</Link></li>
                  <li><Link to="/groups" className="text-light text-decoration-none">Groups</Link></li>
                </>
              ) : (
                <>
                  <li><Link to="/videos" className="text-light text-decoration-none">Videos</Link></li>
                  <li><Link to="/news" className="text-light text-decoration-none">News</Link></li>
                  <li><Link to="/articles" className="text-light text-decoration-none">Articles</Link></li>
                </>
              )}
            </ul>
          </div>
          <div className="col-md-2 mb-3">
            <h6>Support</h6>
            <ul className="list-unstyled small">
              <li><Link to="/about" className="text-light text-decoration-none">About</Link></li>
              <li><Link to="/contact" className="text-light text-decoration-none">Contact</Link></li>
            </ul>
          </div>
          <div className="col-md-4 mb-3">
            <h6>Connect With Us</h6>
            <div className="d-flex gap-3">
              <a href="#" className="text-light"><i className="bi bi-facebook"></i></a>
              <a href="#" className="text-light"><i className="bi bi-twitter"></i></a>
              <a href="#" className="text-light"><i className="bi bi-instagram"></i></a>
              <a href="#" className="text-light"><i className="bi bi-youtube"></i></a>
            </div>
          </div>
        </div>
        <hr className="border-secondary" />
        <div className="text-center small">
          <p className="mb-0">&copy; {new Date().getFullYear()} Natakiya. All rights reserved. | Bringing theater to life.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
